import { render, staticRenderFns } from "./text-filters-1p1c.vue?vue&type=template&id=f61fa57c&scoped=true&"
import script from "./text-filters-1p1c.vue?vue&type=script&lang=js&"
export * from "./text-filters-1p1c.vue?vue&type=script&lang=js&"
import style0 from "./text-filters-1p1c.vue?vue&type=style&index=0&id=f61fa57c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61fa57c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VContainer,VFlex,VIcon,VLayout,VSkeletonLoader})
